import { styled, Stack } from '@mui/material';

export const FileList = styled(Stack)(({ theme }) => ({
  gap: 8,
}));
